import cn from 'classnames';
import CircularProgress from '../CircularProgress';
import RenderOnlyOnClient from '../RenderOnlyOnClient';
import { AppLoaderVariant } from './types';
import styles from './AppLoader.module.scss';

type AppLoaderProps = {
  variant?: AppLoaderVariant;
  className?: string;
};

const AppLoader = ({ variant = 'blurred', className }: AppLoaderProps) => {
  const variantClassName = cn(
    {
      [styles.backdrop]: true,
      [styles.backdropBlurred]: variant === 'blurred',
      [styles.backdropFilled]: variant === 'filled',
    },
    className,
  );

  return (
    <RenderOnlyOnClient>
      <div className={variantClassName}>
        <CircularProgress />
      </div>
    </RenderOnlyOnClient>
  );
};

export default AppLoader;
